import { Component, OnInit, Inject } from '@angular/core';
import { CookieService } from 'ngx-cookie-service';
import { SharedService } from 'src/app/shared.service';
import { TranslateService } from '@ngx-translate/core';
import {Router} from "@angular/router";
import { DashboardComponent } from '../dashboard.component';
import { MatRadioChange } from '@angular/material/radio';
import { MatBottomSheet, MatBottomSheetRef, MAT_BOTTOM_SHEET_DATA } from '@angular/material/bottom-sheet';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import {MatSliderModule} from '@angular/material/slider';
import { MatSlideToggleChange } from '@angular/material/slide-toggle';

import {DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE} from '@angular/material/core';
import {MomentDateAdapter, MAT_MOMENT_DATE_ADAPTER_OPTIONS} from '@angular/material-moment-adapter';

import * as _moment from 'moment';
// tslint:disable-next-line:no-duplicate-imports

const moment = _moment;

export const MY_FORMATS = {
  parse: {
    dateInput: 'LL',
  },
  display: {
   dateInput: 'YYYY-MM-DD',
    monthYearLabel: 'YYYY',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'YYYY',
  },
};

@Component({
  selector: 'app-mycompany',
  templateUrl: './mycompany.component.html',
  styleUrls: ['./mycompany.component.css'],
  providers: [
    // `MomentDateAdapter` can be automatically provided by importing `MomentDateModule` in your
    // application's root module. We provide it at the component level here, due to limitations of
    // our example generation script.
    {
      provide: DateAdapter,
      useClass: MomentDateAdapter,
      deps: [MAT_DATE_LOCALE, MAT_MOMENT_DATE_ADAPTER_OPTIONS]
    },

    {provide: MAT_DATE_FORMATS, useValue: MY_FORMATS},
  ],
})
export class MycompanyComponent implements OnInit {

  constructor(public parent: DashboardComponent, private service:SharedService, private cookieService: CookieService, public translate: TranslateService, private router:Router, private _bottomSheet: MatBottomSheet) {

    translate.addLangs(['en', 'ro']);
    translate.setDefaultLang('en');

    const browserLang = this.parent.getLanguage();
    translate.use(browserLang.match(/en|ro/) ? browserLang : 'en');
   }

   openBottomSheet(a:any): void {
    this._bottomSheet.open(BottomSheetOverviewExampleSheet, {  data: {
      bankAccount: a,
      parent: this.parent
    }});
  }

  FromDate = new FormControl(moment());
  ToDate = new FormControl(moment());
  selectedFile: File = null;
  newBlogForm: FormGroup;
  newCompanyLogo:FormGroup;
  AccountingMasterData:any;

  ShowMFA:boolean;
  ShowMFACompanyDelete:boolean;
  MFAToken:string;

  Company:any;
  loading:boolean;
  showAddNewAddressPopUp:boolean;
  showAddNewAgentPopUp:boolean;
  ShowDeleteBankAccountQuestion:boolean;
  ShowDeleteAdministrationQuestion:boolean;
  DeletingDocuments:any[];
  Filter: {[k: string]: any} = {};

  newAdministration:any;
  newAddress:any;
  newAddressCountry:any;
  newBankAccount:any;
  newAgent:any;
  newAgentAddress:any;
  currentAgent:any;
  currentbankAccount:any;
  newSeries:any;
  currentAdministration:any;
  Companies:any[];
  SlaveCompany:any;

  MasterAdministration:any;
  SlaveAdministration:any;

  MasterSeries:any;
  SlaveSeries:any;
  

  ngOnInit(): void {
    this.GetCompanyByID();
    this.initializeAddAddressForm();
    this.GetAccountingMasterData();

    this.newCompanyLogo = new FormGroup({
      Name: new FormControl(null),
      UploadedFile: new FormControl(null)
    });

    this.newBlogForm = new FormGroup({
      Name: new FormControl(null),
      UploadedFile: new FormControl(null)
    });
  }

  onSelectFile(fileInput: any) {
    this.selectedFile = <File>fileInput.target.files[0];
  }

  initializeAddAddressForm(){
    this.newAddress = new FormGroup({
  
      Country:new FormControl('', [Validators.required]),
      StateProvince:new FormControl('', [Validators.required]),
      City:new FormControl('', [Validators.required]),
      AddressLine:new FormControl('', [Validators.required]),
      ZipCode:new FormControl(''),
    });
  }

  initializeAddAgentForm(){
    this.newAgent = new FormGroup({
  
      Name:new FormControl('', [Validators.required]),
      Phone:new FormControl(''),
      Email:new FormControl(''),
      Function:new FormControl('', [Validators.required]),
      Address:new FormControl('', [Validators.required]),
      Department:new FormControl('')
    });

    this.newAgent.controls['Department'].value = this.AccountingMasterData.Departments[0];

    if(this.currentAgent != null && this.currentAgent !== undefined){
      this.newAgent.ID = this.currentAgent.ID;
      this.newAgentAddress = JSON.parse(JSON.stringify(this.currentAgent.AllocatedAddress));

      this.newAgent.controls['Name'].value = this.currentAgent.Name;
      this.newAgent.controls['Phone'].value = this.currentAgent.Phone;
      this.newAgent.controls['Email'].value = this.currentAgent.Email;
      this.newAgent.controls['Function'].value = this.currentAgent.Function;
      this.newAgent.controls['Address'].value = this.newAgentAddress;
      this.newAgent.controls['Department'].value = this.currentAgent.Department;
    }
  }

  initializeNewBankAccount(){
    this.newBankAccount = {
      AccountNumber: "",
      Currency:null,
      Bank:null,
      Balance:null,
    };
  }

  initializeNewAdministration(){
    this.newAdministration = {
      Name: "",
      ID:0,
      Company:{
        ID: this.Company.ID
      },
    };
  }

  initializeNewSeries(){
    this.newSeries = {
      Series: "",
      GeneralDocTypeObject:null,
      Company:this.Company,
      HighestValue:"0",
      IsActive:true,
    };
  }

  InitializeFilter(){

    this.Filter = {};
    this.Filter.FromDate = null;
    this.Filter.ToDate = null;
    this.Filter.Administration = {};
    this.Filter.AccountingSeries = {};
    this.Filter.Product = "";
    this.Filter.Partner = {};
    this.Filter.DocumentNumber = "";
    this.Filter.DocumentStatus = {};
    this.Filter.Period = {};
    this.Filter.Period = null;
    this.Filter.Country = {};
    this.Filter.Country = null;
    this.Filter.Currency = {};
    this.Filter.Currency = null;

    this.Filter.Pager = {};
    this.Filter.Pager.PageIndex = 1;
    this.Filter.Pager.PageSize = 50;
    this.Filter.Pager.TotalCount = 0;
    this.Filter.ExchangeToTargetCurrency = false;
  }

  compareFn(c1: any, c2: any): boolean {
    return c1 && c2 ? c1.ID === c2.ID : c1 === c2;
}

compareFnID(c1: any, c2: any): boolean {
  return c1 && c2 ? c1.ID === c2 : c1 === c2;
}

AddCompanyAdministration(){
  var request = {
    Administration:this.newAdministration,
    User:this.parent.User,
    Language:this.parent.getLanguage(),
  };
  
    this.parent.loading = true;

    this.service.AddAdministration(request).subscribe(response => {
   
      if(response["Status"] != 1){
        this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
      }
      else if(response["Status"] == 1){
        var id = response["ID"];
        this.newAdministration.ID = id;
        this.Company.Administrations.push(JSON.parse(JSON.stringify(this.newAdministration)));
      }
      
      this.newAdministration = null;
      this.parent.loading = false;
    });
}

  GetCompanyByID(){

    var request = {
      User:this.parent.User,
      Language:this.parent.getLanguage(),
      CompanyID:this.parent.Company.ID
    };

    this.loading = true;

    this.service.GetCompanyByID(request).subscribe(response => {
   
      if(response["Status"] != 1){
      
      }
      else if(response["Status"] == 1){
        this.Company = response["Company"];
        this.GetCompanySMTPConfigs();
      }
   
      this.loading = false;
    });
  }

  GetAccountingMasterData(){

    var request = {
      User:this.parent.User,
      Language:this.parent.getLanguage(),
    };

    this.loading = true;

    this.service.GetAccountingMasterData(request).subscribe(response => {
   
      if(response["Status"] != 1){
      
      }
      else if(response["Status"] == 1){
        this.AccountingMasterData = response;
      }
   
      this.loading = false;
    });
  }

  GetCompanyBankAccounts(){

    var request = {
      User:this.parent.User,
      Language:this.parent.getLanguage(),
      CompanyID:this.parent.Company.ID
    };

    this.loading = true;

    this.service.GetCompanyBankAccounts(request).subscribe(response => {
   
      if(response["Status"] != 1){
        this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
      }
      else if(response["Status"] == 1){
        this.Company.Banks = response["Banks"];
      }
   
      this.loading = false;
    });
  }

  UpdateCompanyData(){

    var request = {
      User:this.parent.User,
      Language:this.parent.getLanguage(),
      Company:this.Company
    };

    this.parent.loading = true;

    this.service.UpdateCompanyData(request).subscribe(response => {
   
      if(response["Status"] != 1){
        this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
      }
      else if(response["Status"] == 1){
        this.parent.openSnackBar("Success", "OK", "light-info-snackbar");
      }
   
      this.parent.loading = false;
    });
  }

  tabClick(tab) {
    if(tab.index == 0){
      this.GetCompanyByID();
    }
    else if(tab.index == 1){
      this.GetCompanyBankAccounts();
    }
    else if(tab.index == 4){
      this.GetCompanyNewRelationshipMasteData();
    }
    else if(tab.index == 5){
      this.GetPrinterSettings();
    }
    else if(tab.index == 6){
      this.GetDeletingDocuments();
    }
    else if(tab.index == 7){
      this.GetCompanyEFacturaGeneralData();
    }
  }

  EFacturaGeneralData:any;
  ShowANAFRedirectionNotification:boolean = false;

  ResetANAFAuthCodeAndEToken(){
 
    var request = {
      User:this.parent.User,
      Language:this.parent.getLanguage(),
    };
  
    this.parent.loading = true;
  
    this.service.PrepareCompanyEFacturaAwaitingToken(request).subscribe(response => {
   
      if(response["Status"] != 1){
        this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
      }
      else if(response["Status"] == 1){
        this.parent.RedirectToURLNewTab(this.EFacturaGeneralData.UserRedirectURL);
        this.ShowANAFRedirectionNotification = false;
      }
  
      this.parent.loading = false;
    });
  }

  GetCompanyEFacturaGeneralData(){
 
    var request = {
      User:this.parent.User,
      Language:this.parent.getLanguage(),
      CompanyID:this.parent.Company?.ID
    };
  
    this.parent.loading = true;
  
    this.service.GetCompanyEFacturaGeneralData(request).subscribe(response => {
   
      if(response["Status"] != 1){
        this.parent.openSnackBar(response["Message"], "OK", "light-info-snackbar");
      }
      else if(response["Status"] == 1){
        this.EFacturaGeneralData = response["EFacturaGeneralData"];
        this.EFacturaSettings = response["EFacturaSettings"];
      }
  
      this.parent.loading = false;
    });
  }

  AddUpdateCompanyEFacturaSettings(){
 
    var request = {
      User:this.parent.User,
      Language:this.parent.getLanguage(),
      EFacturaSettings:this.EFacturaSettings,
    };
  
    this.parent.loading = true;
  
    this.service.AddUpdateCompanyEFacturaSettings(request).subscribe(response => {
   
      if(response["Status"] != 1){
        this.parent.openSnackBar(response["Message"], "OK", "light-info-snackbar");
      }
      else if(response["Status"] == 1){
        this.EFacturaSettings = response["CompanyEFacturaSettings"];
      }
  
      this.parent.loading = false;
    });
  }

  EFacturaSettings:{[k: string]: any} = {};
  PrinterSettings:{[k: string]: any} = {};
  PrinterPersonalSettingsExistance:boolean = false;
  PrinterSettingsUserName:string;

  InitializePersonalPrinterSettings(ps:any){
    this.PrinterSettings = JSON.parse(JSON.stringify(ps));
    this.PrinterSettings.UserID = this.parent.User.Id;
    this.PrinterSettingsUserName = this.parent.User.Email;
    this.PrinterPersonalSettingsExistance = true;
    this.PrinterSettings.ID = null;


  }

  CancelPersonalPrinterSettings(){
    if(this.Company.PrinterSettings != null && this.Company.PrinterSettings?.length > 0){
      this.PrinterSettings = this.Company.PrinterSettings[0];
    }

    if(this.Company.PrinterSettings.some(x => x.UserID?.length > 0)){
      this.PrinterPersonalSettingsExistance = true;
    }
    else{
      this.PrinterPersonalSettingsExistance = false;
    }
  }

  SelectPrinterSettings(p:any){
    if(this.Company.PrinterSettings.some(x => x.UserID?.length > 0)){
      this.PrinterPersonalSettingsExistance = true;
    }
    else{
      this.PrinterPersonalSettingsExistance = false;
    }
  }

  GetPrinterSettings(){
    var request = {
      User:this.parent.User,
      Language:this.parent.getLanguage(),
      CompanyID:this.Company.ID
    };
    
      this.parent.loading = true;

      this.service.GetPrinterSettings(request).subscribe(response => {
     
        if(response["Status"] != 1){
          this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
        }
        else if(response["Status"] == 1){
          this.Company.PrinterSettings = response["PrinterSettings"];

          if(this.Company.PrinterSettings != null && this.Company.PrinterSettings?.length > 0){
            this.PrinterSettings = this.Company.PrinterSettings[0];
          }

          if(this.Company.PrinterSettings.some(x => x.UserID?.length > 0)){
            this.PrinterPersonalSettingsExistance = true;
          }
        }
        
        this.parent.loading = false;
      });
  }

  AddNewCompanySeries(){
    var request = {
      NewSeries:this.newSeries,
      User:this.parent.User,
      Language:this.parent.getLanguage(),
    };
    
      this.parent.loading = true;

      this.service.AddNewCompanySeries(request).subscribe(response => {
     
        if(response["Status"] != 1){
          this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
        }
        else if(response["Status"] == 1){
          var a = response["NewSeries"];
          this.Company.AccountingSeries.push(a);
          this.parent.openSnackBar(response["Message"], "OK", "light-info-snackbar");
        }
        
        this.newSeries = null;
        this.parent.loading = false;
      });
  }

  AddNewAddress(){
    var request = {
      Address:{
          Country:this.newAddress.controls['Country'].value,
          StateProvince:this.newAddress.controls['StateProvince'].value,
          City:this.newAddress.controls['City'].value,
          AddressLine:this.newAddress.controls['AddressLine'].value,
          ZipCode:this.newAddress.controls['ZipCode'].value,
      },
      CompanyID:this.Company.ID,
      User:this.parent.User,
      Language:this.parent.getLanguage(),
    };

    if(this.newAddress.valid){
      this.parent.loading = true;

      this.service.AddCompanyAddress(request).subscribe(response => {
     
        if(response["Status"] != 1){
          this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
        }
        else if(response["Status"] == 1){
          var a = response["Address"];
          this.Company.Addresses.push(a);
          this.parent.openSnackBar("Success", "OK", "light-info-snackbar");
        }
     
        this.initializeAddAddressForm();
        this.showAddNewAddressPopUp = false;
        this.parent.loading = false;
      });
    }

    if(!this.newAddress.valid){
      this.newAddress.controls['Country'].touched = true;
      this.newAddress.controls['StateProvince'].touched = true;
      this.newAddress.controls['City'].touched = true;
      this.newAddress.controls['AddressLine'].touched = true;
      this.newAddress.controls['ZipCode'].touched = true;
      }
  }

  AddUpdateAgent(){
    var request = {
      Agent:{
          ID:this.currentAgent?.ID,
          Name:this.newAgent.controls['Name'].value,
          Phone:this.newAgent.controls['Phone'].value,
          Email:this.newAgent.controls['Email'].value,
          Function:this.newAgent.controls['Function'].value,
          AllocatedAddress:this.newAgent.controls['Address'].value,
          Department:this.newAgent.controls['Department'].value,
          CompanyID:this.Company.ID
      },
      CompanyID:this.Company.ID,
      User:this.parent.User,
      Language:this.parent.getLanguage(),
    };

    if(this.newAgent.valid){
      this.parent.loading = true;

      this.service.AddUpdateAgent(request).subscribe(response => {
     
        if(response["Status"] != 1){
          this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
        }
        else if(response["Status"] == 1){
          
          var agent = response["Agent"];
          var found = false;
          
          this.Company.Agents.forEach(function(a, index) {
            
            if(this[index].ID == agent.ID){
              found = true;
              this[index] = agent;
            }

          }, this.Company.Agents); // use arr as this

          if(found == false){
            this.Company.Agents.push(agent);
          }

        }
     
        this.initializeAddAgentForm();
        this.showAddNewAgentPopUp = false;
        this.parent.loading = false;
      });
    }

    if(!this.newAgent.valid){
      this.newAgent.controls['Name'].touched = true;
      this.newAgent.controls['Function'].touched = true;
      this.newAgent.controls['Address'].touched = true;
      }
  }

  DeleteAgent(id:any){

    var request = {
      User:this.parent.User,
      Language:this.parent.getLanguage(),
      AgentID:id
    };

    this.parent.loading = true;

    this.service.DeleteAgent(request).subscribe(response => {
   
      if(response["Status"] != 1){
        this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
      }
      else if(response["Status"] == 1){
        this.parent.openSnackBar("Success", "OK", "light-info-snackbar");
        this.Company.Agents = this.Company.Agents.filter(item => item.ID != id);
      }
   
      this.parent.loading = false;
    });
  }

  UpdateAddress(a:any){
    var request = {
      Address:a,
      User:this.parent.User,
      Language:this.parent.getLanguage(),
    };

    this.parent.loading = true;

    this.service.UpdateAddress(request).subscribe(response => {
   
      if(response["Status"] != 1){
        this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
      }
      else if(response["Status"] == 1){
        this.parent.openSnackBar("Success", "OK", "light-info-snackbar");
      }
     
      this.parent.loading = false;
    });
  }

  DeleteCompanyAddress(AddressID:any){
    var request = {
      AddressID:AddressID,
      CompanyID:this.Company.ID,
      User:this.parent.User,
      Language:this.parent.getLanguage(),
    };

    this.parent.loading = true;

    this.service.DeleteCompanyAddress(request).subscribe(response => {
   
      if(response["Status"] != 1){
        this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
      }
      else if(response["Status"] == 1){
        this.parent.openSnackBar("Success", "OK", "light-info-snackbar");
        this.Company.Addresses = this.Company.Addresses.filter(item => item.ID != AddressID);
      }
     
      this.parent.loading = false;
    });
  }

  AddCompanyBankAccount(){
    var request = {
      CompanyID:this.Company.ID,
      User:this.parent.User,
      Language:this.parent.getLanguage(),
      BankID:this.newBankAccount.Bank.ID,
      CurrencyID:this.newBankAccount.Currency.ID,
      BankAccount:this.newBankAccount.AccountNumber
    };

    this.parent.loading = true;

    this.service.AddCompanyBankAccount(request).subscribe(response => {
   
      if(response["Status"] != 1){
        this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
      }
      else if(response["Status"] == 1){
        this.parent.openSnackBar("Success", "OK", "light-info-snackbar");
        var BankAccount = response["BankAccount"];
        var found = false;

        this.Company.Banks.forEach(b => {

          if(b.ID == BankAccount.BankID){
            b.BankAccounts.push(BankAccount);
            found = true;
          }

        });

        if(found == false){
          this.GetCompanyBankAccounts();
        }

        this.newBankAccount = null;
      }
     
      this.parent.loading = false;
    });
  }

  UpdateCompanyBankAccountsBulk(){
    this.Company.Banks.forEach(b => {

      b.BankAccounts.forEach(account => {
        this.UpdateCompanyBankAccount(account);
      });

    });
  }

  UpdateCompanyBankAccount(bankAccount:any){
    var request = {
      CompanyID:this.Company.ID,
      User:this.parent.User,
      Language:this.parent.getLanguage(),
      BankAccount:bankAccount
    };

    this.parent.loading = true;

    this.service.UpdateCompanyBankAccount(request).subscribe(response => {
   
      if(response["Status"] != 1){
        this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
      }
      else if(response["Status"] == 1){
        this.parent.openSnackBar("Success", "OK", "light-info-snackbar");
      }
     
      this.parent.loading = false;
    });
  }

  UpdateAccountingSeries(series:any){
    var request = {
      User:this.parent.User,
      Language:this.parent.getLanguage(),
      Series:series
    };

    this.parent.loading = true;

    this.service.UpdateAccountingSeries(request).subscribe(response => {
   
      if(response["Status"] != 1){
        this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
      }
      else if(response["Status"] == 1){
        this.parent.openSnackBar("Success", "OK", "light-info-snackbar");
      }
     
      this.parent.loading = false;
    });
  }

  AddAgentSignature(data:any){
    
    const request = new FormData();
    request.append('User.Id', JSON.stringify(this.parent.User.Id));
    request.append('Language', this.parent.getLanguage());
    request.append('Name', data.Name);
    request.append('UploadedFile', this.selectedFile);
    request.append('AgentID', this.currentAgent.ID);

    this.parent.loading = true;

    this.service.AddAgentSignature(request).subscribe(response => {
   
      if(response["Status"] != 1){
        this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
      }
      else if(response["Status"] == 1){
        this.parent.openSnackBar("Success", "OK", "light-info-snackbar");
      }
     
      this.showAddNewAgentPopUp = false;
      this.parent.loading = false;
      this.GetCompanyByID();
    });
  }

  AddSeriesLogo(SeriesID:any){
    
    const request = new FormData();
    request.append('User.Id', JSON.stringify(this.parent.User.Id));
    request.append('Language', this.parent.getLanguage());
    request.append('UploadedFile', this.selectedFile);
    request.append('SeriesID', SeriesID);

    this.parent.loading = true;

    this.service.AddSeriesLogo(request).subscribe(response => {
   
      if(response["Status"] != 1){
        this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
      }
      else if(response["Status"] == 1){
        this.parent.openSnackBar("Success", "OK", "light-info-snackbar");
      }
     
      this.parent.loading = false;
    });
  }

  AskDeleteBankAccountQuestion(bankAccount:any){
    this.ShowDeleteBankAccountQuestion = true;
    this.currentbankAccount = bankAccount;
  }

  AskDeleteAdministrationQuestion(a:any){
    this.ShowDeleteAdministrationQuestion = true;
    this.currentAdministration = a;
  }
  
  DeleteCompanyBankAccount(){
    var request = {
      ID:this.currentbankAccount.ParentDBID,
      User:this.parent.User,
      Language:this.parent.getLanguage(),
    };

    this.parent.loading = true;

    this.service.DeleteCompanyBankAccount(request).subscribe(response => {
   
      if(response["Status"] != 1){
        this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
      }
      else if(response["Status"] == 1){
        this.parent.openSnackBar("Success", "OK", "light-info-snackbar");
        
        this.Company.Banks.forEach(function(b, index) {
            
          b.BankAccounts.forEach(function(a, index2) {
            
            if(this[index2].ParentDBID == request.ID){
              b.BankAccounts.splice(index2, 1);
            }
  
          }, b.BankAccounts); // use arr as this

        }, this.Company.Agents); // use arr as this
      }
     
      this.ShowDeleteBankAccountQuestion = false;
      this.parent.loading = false;
    });
  }

  DeleteCompanyAdministration(){
    var request = {
      ID:this.currentAdministration.ID,
      User:this.parent.User,
      Language:this.parent.getLanguage(),
    };

    this.parent.loading = true;

    this.service.DeleteAdministration(request).subscribe(response => {
   
      if(response["Status"] != 1){
        this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
      }
      else if(response["Status"] == 1){
            
          this.Company.Administrations.forEach(function(a, index) {
            
            if(this[index].ID == request.ID){
              this.splice(index, 1);
            }
  
          }, this.Company.Administrations); 
      }
     
      this.ShowDeleteAdministrationQuestion = false;
      this.parent.loading = false;
    });
  }

  UpdateAccountingSeriesActiveFlag(series:any){

    var request = {
      User:this.parent.User,
      Language:this.parent.getLanguage(),
      SeriesID:series.ID,
      ActiveFlag:series.IsActive
    };

    this.parent.loading = true;

    this.service.UpdateAccountingSeriesActiveFlag(request).subscribe(response => {
   
      if(response["Status"] != 1){
        this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
      }
      else if(response["Status"] == 1){
        this.parent.openSnackBar("Success", "OK", "light-info-snackbar");
      }
     
      this.parent.loading = false;
    });
  }
  
  DeleteAccountingSeries(SeriesID:any){
    var request = {
      SeriesID:SeriesID,
      User:this.parent.User,
      Language:this.parent.getLanguage(),
    };

    this.parent.loading = true;

    this.service.DeleteAccountingSeries(request).subscribe(response => {
   
      if(response["Status"] != 1){
        this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
      }
      else if(response["Status"] == 1){
        this.parent.openSnackBar("Success", "OK", "light-info-snackbar");
        this.Company.AccountingSeries = this.Company.AccountingSeries.filter(item => item.ID != SeriesID);
      }
     
      this.parent.loading = false;
    });
  }

  SMTPConfigs:any[];
  SMTPEmails:any[];
  loadingUser:boolean;
  CurrenctSMTP:any;
  ShowDeleteSMTPQuestion:boolean;
  ShowDeleteSMTPEmailQuestion:boolean;
  CurrenctSMTPEmail:any;
  NewSMTPEmail:{[k: string]: any} = {};
  NewSMTP:{[k: string]: any} = {};

  GetCompanySMTPConfigs(){
    var request = {
      User:this.parent.User,
      Language:this.parent.getLanguage(),
      CompanyID:this.Company.ID
    };

    this.parent.loading = true;
    this.service.GetCompanySMTPConfigs(request).subscribe(response => {
   
      if(response["Status"] != 1){
        this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
      }
      else if(response["Status"] == 1){
        this.SMTPConfigs = response["SMTPConfigs"];
        this.NewSMTPEmail = null;
        this.NewSMTP = null;
      }

      this.parent.loading = false;
    });

    if(this.SMTPConfigs == null || this.SMTPConfigs.length == 0){
      this.InitializeNewSMTP();
    }
  }

  GetCompanySMTPEmails(SMTPID:any){
    var request = {
      User:this.parent.User,
      Language:this.parent.getLanguage(),
      SMTPID:SMTPID
    };

    this.loadingUser = true;

    this.service.GetCompanySMTPEmails(request).subscribe(response => {
   
      if(response["Status"] != 1){
        this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
      }
      else if(response["Status"] == 1){
        this.SMTPEmails = response["Emails"];
      }
     
      this.loadingUser = false;
    });
  }

  AddUpdateCompanySMTPEmail(EmailModel:any){
    var request = {
      User:this.parent.User,
      Language:this.parent.getLanguage(),
      Email:EmailModel
    };

    this.parent.loading = true;

    this.service.AddUpdateCompanySMTPEmail(request).subscribe(response => {
   
      if(response["Status"] != 1){
        this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
      }
      else if(response["Status"] == 1){
        this.GetCompanySMTPEmails(this.CurrenctSMTP.ID);
        this.NewSMTPEmail = null;
      }
     
      this.parent.loading = false;
    });
  }

  AddUpdateSMTPServerConfig(SMTPSettings:any){
    var request = {
      User:this.parent.User,
      Language:this.parent.getLanguage(),
      SMTPSettings:SMTPSettings
    };

    this.parent.loading = true;

    this.service.AddUpdateSMTPServerConfig(request).subscribe(response => {
   
      if(response["Status"] != 1){
        this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
      }
      else if(response["Status"] == 1){
        this.GetCompanySMTPConfigs();
      }
     
      this.parent.loading = false;
    });
  }

  DeleteSMTP(SMTPID:number){
    var request = {
      User:this.parent.User,
      Language:this.parent.getLanguage(),
      SMTPID:SMTPID
    };

    this.parent.loading = true;

    this.service.DeleteSMTPConfig(request).subscribe(response => {
   
      if(response["Status"] != 1){
        this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
      }
      else if(response["Status"] == 1){
        this.GetCompanySMTPConfigs();
      }
     
      this.parent.loading = false;
    });
  }

  DeleteSMTPEmail(ID:number){
    var request = {
      User:this.parent.User,
      Language:this.parent.getLanguage(),
      EmailID:ID
    };

    this.parent.loading = true;

    this.service.DeleteSMTPEmail(request).subscribe(response => {
   
      if(response["Status"] != 1){
        this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
      }
      else if(response["Status"] == 1){
        this.GetCompanySMTPEmails(this.CurrenctSMTP.ID);
      }
     
      this.parent.loading = false;
    });
  }
  
  InitializeNewSMTPEmail(){
    this.NewSMTPEmail = {};
    this.NewSMTPEmail.ID = 0;
    this.NewSMTPEmail.Email = "";
    this.NewSMTPEmail.Password = "";
    this.NewSMTPEmail.SMTPServerID = this.CurrenctSMTP.ID;
    this.NewSMTPEmail.IsDefault = false;
    this.NewSMTPEmail.HidePassword = true;
    this.NewSMTPEmail.UserID = this.parent.User.Id;
  }

  InitializeNewSMTP(){
    this.NewSMTP = {};
    this.NewSMTP.ID = 0;
    this.NewSMTP.SMTPServer = "";
    this.NewSMTP.Port = "";
    this.NewSMTP.CompanyID = this.Company.ID;
  }

  OpenNewCompanyRelationship(){
    this.ShowNewCompanyRelationshipContainer = true;

    this.SlaveCompany = undefined;
    this.MasterAdministration = undefined;
    this.SlaveAdministration = undefined;
    this.MasterSeries = undefined;
    this.SlaveSeries = undefined;
  }

  ShowNewCompanyRelationshipContainer:boolean = false;

  GetCompanyNewRelationshipMasteData(){
    var request = {
      User:this.parent.User,
      Language:this.parent.getLanguage(),
      ExcludeInactiveRelationships:false,
    };

    this.parent.loading = true;

    this.service.GetCompanyNewRelationshipMasteData(request).subscribe(response => {
   
      if(response["Status"] != 1){
        this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
      }
      else if(response["Status"] == 1){
        this.Company = response["Company"];
        this.Companies = response["Companies"];

        this.SlaveCompany = undefined;
        this.MasterAdministration = undefined;
        this.SlaveAdministration = undefined;
        this.MasterSeries = undefined;
        this.SlaveSeries = undefined;
      }
     
      this.parent.loading = false;
    });
  }

  GetCompanyRelationships(){
    var request = {
      User:this.parent.User,
      Language:this.parent.getLanguage(),
      CompanyID:this.Company.ID
    };

    this.parent.loading = true;

    this.service.GetCompanyRelationships(request).subscribe(response => {
   
      if(response["Status"] != 1){
        this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
      }
      else if(response["Status"] == 1){
        this.Company.Relationships = response["Relationships"];
      }
     
      this.parent.loading = false;
    });
  }

  AddCompanyRelationShip(){
    var request = {
      User:this.parent.User,
      Language:this.parent.getLanguage(),
      MasterCompany:this.Company,
      SlaveCompany:this.SlaveCompany,
      MasterAdministration:this.MasterAdministration,
      SlaveAdministration:this.SlaveAdministration,
      MasterSeries:this.MasterSeries,
      SlaveSeries:this.SlaveSeries
    };

    this.parent.loading = true;

    this.service.AddCompanyRelationShip(request).subscribe(response => {
   
      if(response["Status"] != 1){
        this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
      }
      else if(response["Status"] == 1){
      
      }
     
      this.parent.loading = false;
    });
  }

  UpdateCompanyRelationshipProfitMargin(r){
    var request = {
      User:this.parent.User,
      Language:this.parent.getLanguage(),
      Relationship:r
    };

    this.parent.loading = true;

    this.service.UpdateCompanyRelationshipProfitMargin(request).subscribe(response => {
   
      if(response["Status"] != 1){
        this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
      }
      else if(response["Status"] == 1){

        var relationship = response["Relationship"];

        this.Company.Relationships.forEach(r => {
          if(r.RelationshipID == relationship.RelationshipID){
            r = relationship;
          }
        });

        this.parent.openSnackBar(response["Message"], "OK", "light-info-snackbar");
      }
     
      this.parent.loading = false;
    });
  }

  AddUpdatePrinterSettings(PrinterSettings:any){
    var request = {
      User:this.parent.User,
      Language:this.parent.getLanguage(),
      PrinterSettings:PrinterSettings
    };

    this.parent.loading = true;

    this.service.AddUpdatePrinterSettings(request).subscribe(response => {
   
      if(response["Status"] != 1){
        this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
      }
      else if(response["Status"] == 1){
        this.Company.PrinterSettings = response["PrinterSettings"];

        if(this.Company.PrinterSettings != null && this.Company.PrinterSettings?.length > 0){
          this.PrinterSettings = this.Company.PrinterSettings[0];
        }

        if(this.Company.PrinterSettings.some(x => x.UserID?.length > 0)){
          this.PrinterPersonalSettingsExistance = true;
        }
      }
     
      this.parent.loading = false;
    });
  }

  toggleUsePersonalAutoPrintSettings(event: MatSlideToggleChange){
    this.parent.User.Settings.UsePersonalAutoPrintSettings = event.checked;
    this.AddUpdateUserSettings();
  }

  AddUpdateUserSettings(){

    var request = {
      User:this.parent.User,
      Settings:this.parent.User.Settings,
      Language:this.parent.getLanguage()
    };

    this.parent.loading = true;

    this.service.AddUpdateUserSettings(request).subscribe(response => {
   
      if(response["Status"] != 1){
        this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
      }
      else if(response["Status"] == 1){
        localStorage.setItem('User', JSON.stringify(this.parent.User));
        this.parent.setLanguage(this.parent.User.Settings.Language.Name.toLowerCase());
        this.parent.translate.use(this.parent.User.Settings.Language.Name.toLowerCase());

        this.parent.openSnackBar(response["Message"], "OK", "light-info-snackbar");
      }
   
      this.parent.loading = false;
    });
  }

  GetDeletingDocuments(){
    var request = {
      User:this.parent.User,
      Language:this.parent.getLanguage(),
    };

    this.parent.loading = true;

    this.service.GetDeletingDocuments(request).subscribe(response => {
   
      if(response["Status"] != 1){
        this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
      }
      else if(response["Status"] == 1){
        this.DeletingDocuments = response["DeletingDocuments"];
      }
     
      this.parent.loading = false;
    });
  }

  ShowDeletingMasterEntitiesErrorResults:boolean;
  ErrorsList:any[];

  DeteleData(){
    var request = {
      User:this.parent.User,
      Language:this.parent.getLanguage(),
      DeletingMasterEntities:this.DeletingMasterEntities,
      Exceptions:this.DeletingMasterEntitiesExceptions,
      Filter:this.Filter,
      AppPin:this.parent.AppPIN
    };

    this.parent.loading = true;
    this.ShowBulkDeleteMasterContainer = false;

    this.service.DeteleData(request).subscribe(response => {
   
      if(response["Status"] != 1){
        this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
      }
      else if(response["Status"] == 1){
        this.DeletingMasterEntities = [];
        this.ErrorsList = JSON.parse(JSON.stringify(response["Errors"]));
        this.ShowDeletingMasterEntitiesErrorResults = true;
        this.ShowMFA = false;
      }
     
      this.parent.loading = false;
    });
  }

  ShowDeletingMasterEntitiesErrorResultsDetails:boolean;

  OpenDeletingEntitiesErrors(DeletingMasterEntity:any){
    this.SelectedDeletingMasterEntity = DeletingMasterEntity;
    this.ShowDeletingMasterEntitiesErrorResultsDetails = true;
  }
  
  GetDeletingEntities(DeletingMasterEntity:any){
    
    var DeletingDocuments = [];
    DeletingDocuments.push(DeletingMasterEntity.DocumentCategory);
    
    var request = {
      User:this.parent.User,
      Language:this.parent.getLanguage(),
      DeletingDocuments:DeletingDocuments,
      Filter:DeletingMasterEntity.Filter
    };

    this.parent.loading = true;

    this.service.GetDeletingEntities(request).subscribe(response => {
   
      if(response["Status"] != 1){
        this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
      }
      else if(response["Status"] == 1){
        var resultEntities = response["Entities"];

        resultEntities.forEach(element => {
          if(element.DocumentCategory.ID == DeletingMasterEntity.DocumentCategory.ID){
            DeletingMasterEntity.Documents = element.Documents;
            DeletingMasterEntity.IsSelected = true;
            this.SelectedDeletingMasterEntity = DeletingMasterEntity;
          }
        });

        this.InitializeDeletingExceptionsEntities(this.SelectedDeletingMasterEntity);
        this.DeletingEntitiesMasterContainer = true;
        this.ShowBulkDeleteMasterContainer = false;
      }
     
      this.parent.loading = false;
    });
  }

  InitializeDeletingExceptionsEntities(DeletingMasterEntity:any){
      this.DeletingMasterEntitiesExceptions.forEach(element => {
          if(element.DocumentCategory.ID == DeletingMasterEntity.DocumentCategory.ID){
            if(element.Documents?.length > 0){
              DeletingMasterEntity.Documents.forEach(e => {
                if(element.Documents?.some((doc) => doc.ID === e.ID)){
                  e.IsSelected = false;
                }
              });
            }
          }
      });
  }

  SelectDeselectDeletingDocument(doc:any, categoryID:number){
    doc.IsSelected = !doc.IsSelected;

    if(doc.IsSelected){
      this.DeleteDeletingExceptionsEntities(doc, categoryID);
    }
    else{
      this.AddDeletingExceptionsEntities(doc, categoryID);
    }
  }

  AddDeletingExceptionsEntities(doc:any, categoryID:number){
    this.DeletingMasterEntitiesExceptions.forEach(element => {
      if(element.DocumentCategory.ID == categoryID){
        if(element.Documents != null){
            if(!element.Documents?.some((d) => d.ID === doc.ID)){
              element.Documents.push(doc);
            }
        }
      }
    });
  }

  DeleteDeletingExceptionsEntities(doc:any, categoryID:number){
    this.DeletingMasterEntitiesExceptions.forEach(element => {
      if(element.DocumentCategory.ID == categoryID){
        if(element.Documents != null){
            if(element.Documents?.some((d) => d.ID === doc.ID)){
              element.Documents = element.Documents.filter(x => x.ID != doc.ID);
            }
        }
      }
    });
  }

  ShowBulkDeleteMasterContainer:boolean;
  DeletingEntitiesMasterContainer:boolean;
  DeletingMasterEntities:any[];
  DeletingMasterEntitiesExceptions:any[];
  SelectedDeletingMasterEntity:any;

  GetDeletingEntitiesCount(){
    var request = {
      User:this.parent.User,
      Language:this.parent.getLanguage(),
      DeletingDocuments:this.DeletingDocuments,
      Filter:this.Filter
    };

    if(request.Filter.FromDate != null){
      request.Filter.FromDate = JSON.parse(JSON.stringify(this.FromDate.value._d.toLocaleDateString()));
      this.Filter.FromDate = JSON.parse(JSON.stringify(this.FromDate.value._d.toLocaleDateString()));
    }

    if(request.Filter.ToDate != null){
      request.Filter.ToDate = JSON.parse(JSON.stringify(this.ToDate.value._d.toLocaleDateString()));
      this.Filter.ToDate = JSON.parse(JSON.stringify(this.ToDate.value._d.toLocaleDateString()));
    }

    this.parent.loading = true;

    this.service.GetDeletingEntitiesCount(request).subscribe(response => {
   
      if(response["Status"] != 1){
        this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
      }
      else if(response["Status"] == 1){
        this.ShowBulkDeleteMasterContainer = true;
        this.DeletingMasterEntities = response["DeletingMasterEntities"];
        this.DeletingMasterEntitiesExceptions = JSON.parse(JSON.stringify(response["DeletingMasterEntities"]));

        this.FromDate = new FormControl(moment(this.Filter.FromDate));
        this.ToDate = new FormControl(moment(this.Filter.ToDate));
      }
      this.parent.loading = false;
    });
  }

  ClearPeriod(){
    this.Filter.Period = null;
  }

  AddActiveFilter(filterName:string, filterType:string){

    if(filterType == "Period"){
      this.Filter.FromDate = null;
      this.Filter.ToDate = null;

      this.FromDate = new FormControl(moment(this.Filter.FromDate));
      this.ToDate = new FormControl(moment(this.Filter.ToDate));
    }
  }

  loadingMFA:boolean;

  OpenMFA(){
    this.ShowMFA = true;
    this.ShowBulkDeleteMasterContainer = false;
  }

  GetMFAResult(){
   
    var request = {
      User:this.parent.User,
      Language:this.parent.getLanguage(),
      Token:this.MFAToken
    };
    
    this.loadingMFA = true;
  
    this.service.VerifyMFAToken(request).subscribe(response => {
  
      if(response["Status"] != 1){
        this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
      }
      else if(response["Status"] == 1){
        this.DeteleData();
      }
      
      this.loadingMFA = false;
    });
  }

  GetMFAResultCompanyDelete(){
   
    var request = {
      User:this.parent.User,
      Language:this.parent.getLanguage(),
      Token:this.MFAToken
    };
    
    this.loadingMFA = true;
  
    this.service.VerifyMFAToken(request).subscribe(response => {
  
      if(response["Status"] != 1){
        this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
      }
      else if(response["Status"] == 1){
        this.DeleteCompany();
      }
      
      this.loadingMFA = false;
    });
  }

  DeleteCompany(){
    var request = {
      User:this.parent.User,
      Language:this.parent.getLanguage(),
      AppPin:this.parent.AppPIN,
      Company:this.parent.Company
    };

    this.parent.loading = true;

    this.service.DeleteCompany(request).subscribe(response => {
   
      if(response["Status"] != 1){
        this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
      }
      else if(response["Status"] == 1){
        this.parent.openSnackBar(response["Message"], "OK", "light-info-snackbar", 500000);
        this.router.navigate(['login/success/company/select'])
      }
     
      this.parent.loading = false;
    });
  }

  OpenMFACompanyDelete(){
    this.ShowMFACompanyDelete = true;
  }

  AddUpdateCompanyLogo(){
    
    const request = new FormData();
    request.append('User.Id', JSON.stringify(this.parent.User.Id));
    request.append('Language', this.parent.getLanguage());
    request.append('CompanyID', this.Company.ID);
    request.append('UploadedFile', this.selectedFile);

    this.parent.loading = true;

    this.service.AddUpdateCompanyLogo(request).subscribe(response => {
   
      if(response["Status"] != 1){
        this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
      }
      else if(response["Status"] == 1){
        this.parent.openSnackBar("Success", "OK", "light-info-snackbar");
      }
     
      this.showAddNewAgentPopUp = false;
      this.parent.loading = false;
    });
  }
  
  AddUpdateCompanyUXDetails($event){

    if($event.checked == true){
      this.Company.UXDetails.ShowPartnerFinancialData = true;
    }
    else{
      this.Company.UXDetails.ShowPartnerFinancialData = false;
    }

    var request = {
      User:this.parent.User,
      Language:this.parent.getLanguage(),
      Company:this.Company
    };

    this.parent.loading = true;

    this.service.AddUpdateCompanyUXDetails(request).subscribe(response => {
   
      if(response["Status"] != 1){
        this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
      }
      else if(response["Status"] == 1){
        this.parent.openSnackBar(response["Message"], "OK", "light-info-snackbar", 500000);
      }
     
      this.parent.loading = false;
    });
  }

  NewBank: {[k: string]: any} = {};

  AddBank(b:any){
    var request = {
      User:this.parent.User,
      Language:this.parent.getLanguage(),
      Bank:b,
    };

    this.parent.loading = true;

    this.service.AddBank(request).subscribe(response => {
   
      if(response["Status"] != 1){
        this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
      }
      else if(response["Status"] == 1){
        this.parent.GetMasterData();
        this.NewBank.Name = "";
        this.NewBank.Swift = "";
      }
     
      this.parent.loading = false;
    });
  }
}

@Component({
  selector: 'bottom-sheet-overview-example-sheet',
  templateUrl: 'bottom-sheet-overview-example-sheet.html',
})
export class BottomSheetOverviewExampleSheet {
  constructor(private _bottomSheetRef: MatBottomSheetRef<BottomSheetOverviewExampleSheet>, private service:SharedService , @Inject(MAT_BOTTOM_SHEET_DATA) public data: any) {}

  openLink(event: MouseEvent): void {
    this.DeleteCompanyBankAccount();
    this._bottomSheetRef.dismiss();
    event.preventDefault();
  }
  
  DeleteCompanyBankAccount(){
    var request = {
      ID:this.data.bankAccount.ID,
      User:this.data.parent.User,
      Language:this.data.parent.getLanguage(),
    };

    this.data.parent.loading = true;

    this.service.DeleteCompanyBankAccount(request).subscribe(response => {
   
      if(response["Status"] != 1){
        this.data.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
      }
      else if(response["Status"] == 1){
        this.data.parent.openSnackBar("Success", "OK", "light-info-snackbar");
      }
     
      this.data.parent.loading = false;
    });
  }

  closeLink(event: MouseEvent): void {
    this._bottomSheetRef.dismiss();
    event.preventDefault();
  }
}

